import { useState } from 'react';

export const useModalState = (value: boolean = false): [boolean, () => void, () => void] => {
  const [isOpen, setIsOpen] = useState(value);
  return [isOpen, () => setIsOpen(true), () => setIsOpen(false)];
};
